import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tour: false,
  tourAutoShownForCourse: null,
  stuckCounter: 0,
  alerts: [],
  shareJoinCodePromptTeamId: null,
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,

  reducers: {
    updateTour: (state, action) => {
      state.tour = action.payload
    },
    markTourAutoShownForCourse: (state, action) => {
      state.tourAutoShownForCourse = action.payload
    },
    setStuckCounter: (state, action) => {
      state.stuckCounter = action.payload
    },
    updateStuckCounter: (state, action) => {
      state.stuckCounter = action.payload?.stuckCounter ?? action.payload
    },
    createAlert: (state, action) => {
      state.alerts = [...state.alerts, action.payload]
    },
    setShareJoinCodePromptTeamId: (state, action) => {
      state.shareJoinCodePromptTeamId = action.payload
    },
    resetUi: (state) => {
      return { ...initialState }
    },
  },
})

export const {
  updateTour,
  markTourAutoShownForCourse,
  setStuckCounter,
  updateStuckCounter,
  createAlert,
  setShareJoinCodePromptTeamId,
  resetUi,
} = uiSlice.actions

export default uiSlice.reducer
